import React, { useState, useEffect, lazy } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants";

import { Paper, Grid } from "@material-ui/core";
import { Title } from "App/Component/ui";

import { FormProvider } from "./context/FormContext";
import { RenderListPembelian, getPembelianItemByPembelianId } from "./helpers";
import { RESET_STATE_PEMBELIAN_BARANG } from "./ui/DataBarang/helpers";
import { isNull } from "App/utils/helpers";

const DataBarang = lazy(() => import("./ui/DataBarang/DataBarang"));
const Perhitungan = lazy(() => import("./ui/Perhitungan/Perhitungan"));
const FormPembelian = lazy(() => import("./ui/FormPembelian/FormPembelian"));

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function InputPembelianWMS({ data, menu, changeParentData }) {
  const classes = useStyles();

  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <Title title={"Pembelian Perbekalan Farmasi"} />
        <Paper className={classes.paper}>
          <FormPembelian />

          <div className='mt-1'>
            <hr />
          </div>

          <RenderContent
            classes={classes}
            data={data}
            menu={menu}
            changeParentData={changeParentData}
          />
        </Paper>
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data, menu, changeParentData }) => {
  const [formBarang, setFormBarang] = useState(RESET_STATE_PEMBELIAN_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [listPembelian, setListPembelian] = useState([]);

  useEffect(() => {
    (async () => {
      await setNewDataPembelianList(data?.id);
    })();
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPembelianList = async (id) => {
    if (!isNull(id)) {
      const res = await getPembelianItemByPembelianId(id);
      if (res.state) {
        setListPembelian(res.data);
      } else {
        setListPembelian([]);
      }
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6}>
          <DataBarang
            formBarang={formBarang}
            setFormBarang={setFormBarang}
            showModalBarang={showModalBarang}
            setShowModalBarang={setShowModalBarang}
            setNewDataPembelianList={setNewDataPembelianList}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            listPembelian={listPembelian}
            setListPembelian={setListPembelian}
            setNewDataPembelianList={setNewDataPembelianList}
            menu={menu}
            changeParentData={changeParentData}
          />
        </Grid>
      </Grid>
      <div className='mt-2'>
        <RenderListPembelian
          classes={classes}
          formBarang={formBarang}
          listPembelian={listPembelian}
          setFormBarang={setFormBarang}
          showModalBarang={showModalBarang}
          setShowModalBarang={setShowModalBarang}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      </div>
    </>
  );
};
